import { apiClient } from './client';
import { API_ROUTES } from './routes';

export const subscriptionService = {
  async getWelcomeOffer() {
    const response = await apiClient.get(API_ROUTES.SUBSCRIPTIONS.WELCOME_OFFER);
    return response?.data || null;
  },

  async getPlans() {
    const response = await apiClient.get(API_ROUTES.SUBSCRIPTIONS.PLANS);
    return response?.data || null;
  },

  async getMySubscription() {
    const response = await apiClient.get(API_ROUTES.SUBSCRIPTIONS.ME);
    return response?.data || null;
  },

  async createCheckoutSession(plan, currency = 'mad', welcomeOfferPercentOff = null) {
    const response = await apiClient.post(API_ROUTES.SUBSCRIPTIONS.CHECKOUT, { plan, currency, welcome_offer_percent_off: welcomeOfferPercentOff });
    return response?.data || null;
  },

  async createDirectSubscription(plan, paymentMethodId = null, currency = 'mad', welcomeOfferPercentOff = null) {
    const response = await apiClient.post(API_ROUTES.SUBSCRIPTIONS.CREATE_DIRECT, {
      plan,
      payment_method_id: paymentMethodId,
      welcome_offer_percent_off: welcomeOfferPercentOff,
      currency,
    });
    window.dispatchEvent(new Event('subscription-changed'));
    return response?.data || null;
  },

  async openPortal() {
    const response = await apiClient.post(API_ROUTES.SUBSCRIPTIONS.PORTAL);
    return response?.data || null;
  }
};
